import styled from 'styled-components';
import { COLORS, FONTS } from '@app/src/ui';

export const Wrapper = styled.div`
  width: 100%;
  background-color: ${COLORS.LIGHT_GRAY}; 
  padding: 12px 16px;

  @media(min-width: 480px) {
    background-color: ${COLORS.WHITE};
    padding: 0;
  }
`;

export const Text = styled.div`
  display: none;
  font-family: ${FONTS.ROBOTO_REGULAR};
  font-size: 16px;

  @media(min-width: 480px) {
    display: block;
  }
`;

export const Name = styled.span`
  font-family: ${FONTS.ROBOTO_BOLD};
`;
